import { createRoute } from "@routes/utils";

import { supportRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = "all";

const supportRouteMetadata: IRouteMetadataObj<typeof supportRoutesObj> = {
  home: {
    title: "support.title",
    description: "empty",
    lazy: () => import("@/pages/support/page"),
    mode: "index",
    type: "inner",
    icon: "HeadphoneLine",
    breadcrumbs: [],
    permission,
  },
};

export const supportRoutes = createRoute<typeof supportRoutesObj>(
  supportRoutesObj,
  supportRouteMetadata,
);
